import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { COLUMN_2 } from 'Components/frameworks/card/Card.constants';
import { ICONS } from 'Components/utils/icon/icons';
import { useAppContext } from 'Context/ReactAppContext';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { UTC_DATE_TIME_FORMAT } from 'Utils/date/apiDate';
import { Card } from 'Components/frameworks/card/Card';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { Spinner } from 'Components/frameworks/spinner/Spinner';
import { Tabs } from 'Components/frameworks/tabs/Tabs';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { getPlanning, getTabsItems } from './qrcodeProductDressCodeLine.utils';
const NUMBER_OF_DISPLAYED_DAYS = 7;
type Props = {
  dresscodeMissingText: string;
  dresscodeMissingTitle: string;
  noDresscodeText: string;
  noDresscodeTitle: string;
  resortId: string;
  title: string;
};
export const QrcodeProductDresscodeLine = ({
  dresscodeMissingText,
  dresscodeMissingTitle,
  noDresscodeText,
  noDresscodeTitle,
  resortId,
  title,
}: Props) => {
  const appContext = useAppContext();
  const [dresscodePlanning, setDresscodePlanning] = useState([]);
  const [isPlanningLoading, setIsPlanningLoading] = useState(false);
  // Implementation carried on the component side to correct the problem of the timezone of the resort
  useEffect(() => {
    const fetchResortPlanning = async () => {
      setIsPlanningLoading(true);
      const {
        resort: { planning },
      } = await getPlanning(resortId, appContext);
      setDresscodePlanning(planning);
      setIsPlanningLoading(false);
    };

    fetchResortPlanning();
  }, []);
  const trackingData = {
    categoryGA: 'landingPage',
    actionGA: 'CTA_ProgrammeDressCodeDate',
  };
  const track = useTracking(trackingData);
  const language = appContext.locale.slice(0, 2);
  const displayedDays = [];
  const associatedDresscodes = [];

  if (dresscodePlanning.length > 0) {
    for (let i = 0; i < NUMBER_OF_DISPLAYED_DAYS; i++) {
      const day = moment().locale(language).add(i, 'days');
      displayedDays.push(day);
      associatedDresscodes.push(
        dresscodePlanning.filter(
          ({ startDateTime }) =>
            day.dayOfYear() === moment(startDateTime, UTC_DATE_TIME_FORMAT).dayOfYear(),
        ),
      );
    }
  }

  return (
    <SiteContainer className="Line" id="QrcodeProductDresscodeLine" size="small">
      <LineTitle>{title}</LineTitle>
      {isPlanningLoading && (
        <div className="flex items-center justify-center">
          <Spinner size="small" />
        </div>
      )}
      {!isPlanningLoading &&
        (displayedDays.length > 0 ? (
          <Tabs
            className="mt-20"
            hasControlsOnTouch
            isContainerWide
            isScrollable
            items={getTabsItems({
              associatedDresscodes,
              displayedDays,
              dresscodeMissingText,
              dresscodeMissingTitle,
              language,
            })}
            onTabClick={(_, index) => {
              const dayLabel = index === 0 ? 'Today' : `Day_${index}`;
              track({
                labelGA: `%Tab${dayLabel}%`,
              });
            }}
            theme="underlined"
          />
        ) : (
          <Card
            heading={{
              iconName: ICONS.DURATION,
              title: noDresscodeTitle,
            }}
            layout={COLUMN_2}
            text={{
              text: noDresscodeText,
            }}
          />
        ))}
    </SiteContainer>
  );
};
